import { Link } from 'react-router-dom';
import Ecosystem from './Ecosystem';

const techTags = [
  'Agentes IA',
  'SAP Business One',
  'ERP',
  'SaaS',
  'Web',
  'Mobile',
  'APIs',
  'Cloud',
];

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 pb-16 md:pt-32 md:pb-20">
      {/* Background glows */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-primary-500/15 blur-[120px]"></div>
        <div className="absolute top-1/3 -left-40 w-[400px] h-[400px] rounded-full bg-accent-500/10 blur-[120px]"></div>
        <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[120px]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,oklch(var(--background-950))_75%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-800/60 border border-background-700/60 text-xs md:text-sm text-foreground-500 backdrop-blur">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-pulse-glow"></span>
              IA · SOFTWARE · AUTOMATIZACIÓN · INTEGRACIONES
            </span>

            <h1 className="mt-6 text-4xl md:text-5xl xl:text-6xl font-bold font-heading text-foreground-950 leading-[1.1] tracking-tight">
              Tecnología que{' '}
              <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-accent-400 bg-clip-text text-transparent animate-gradient-shift bg-[length:200%_auto]">
                trabaja
              </span>{' '}
              para tu negocio.
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-500 leading-relaxed max-w-2xl">
              En ACOMA diseñamos agentes de inteligencia artificial, software e
              integraciones que conectan personas, procesos y sistemas para
              transformar ideas y problemas reales en soluciones funcionando en
              producción.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 lg:justify-start">
              <Link
                to="/contacto"
                className="w-full sm:w-auto text-center whitespace-nowrap font-medium text-background-950 bg-primary-500 hover:bg-primary-600 rounded-md px-7 py-3.5 transition-colors cursor-pointer glow-primary"
              >
                Cuéntanos tu proyecto
              </Link>
              <Link
                to="/soluciones"
                className="w-full sm:w-auto text-center whitespace-nowrap font-medium text-foreground-900 border border-background-700 hover:border-foreground-500 hover:bg-background-800 rounded-md px-7 py-3.5 transition-colors cursor-pointer"
              >
                Conoce nuestras soluciones
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-2">
              {techTags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs md:text-sm text-foreground-400 whitespace-nowrap px-3 py-1.5 rounded-md bg-background-800/50 border border-background-700/50"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <Ecosystem />
          </div>
        </div>
      </div>
    </section>
  );
}